// jQuery nur für Bibliotheken (slick-carousel) importieren
import $ from 'jquery';
window.$ = window.jQuery = $;

import styleSelect from 'styleselect';
import "slick-carousel";
// import magnificPopup from 'magnific-popup';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import GLightbox from 'glightbox';

document.querySelectorAll('.header_button').forEach(function(button) {
    button.addEventListener('click', function() {
        document.body.classList.toggle("header--shownav");
    });
});

document.querySelectorAll('.nav_close, .nav_overlay').forEach(function(element) {
    element.addEventListener('click', function() {
        document.body.classList.toggle("header--shownav");
    });
});

document.querySelectorAll('.nav_select').forEach(function(select) {
    select.addEventListener('change', function() {
        const url = this.value;
        if(url) {
            location.href = url;
        }
    });
});

document.querySelectorAll("select").forEach(function(select) {
    if (select.id && !select.closest('#management-app')) {
        styleSelect("#" + select.id);
    }
});

document.querySelectorAll(".menu--seminars > a").forEach(function(link) {
    link.addEventListener("click", function(e) {
        e.preventDefault();
        this.parentElement.classList.toggle("menu--viewsubmenu");
    });
});

document.querySelectorAll(".subnav-select").forEach(function(select) {
    select.addEventListener("change", function(e) {
        e.preventDefault();
        window.location.href = this.value;
    });
});


const turnierhelferElement = document.getElementById("Form_Form_Turnierhelfer");
if (turnierhelferElement) {
    function showHideHelfer() {
        const show = turnierhelferElement.checked;
        const elements = [
            document.getElementById("Form_Form_Turnierhelfer_Headline"),
            document.getElementById("Form_Form_Abfahrt_Holder"),
            document.getElementById("Turnierhelfer_Description"),
            ...document.querySelectorAll(".helfer")
        ];
        
        elements.forEach(function(el) {
            if (el) {
                el.style.display = show ? "" : "none";
            }
        });
    }

    turnierhelferElement.addEventListener("change", function() {
        showHideHelfer();
    });

    showHideHelfer();
}

// Alle-Tage/Einzelne-Tage toggle: hides the individual Seminartage checkboxes
// (field "Days") whenever "Alle Tage" is picked. Shared by the public
// registration form (formName "Form") and the management "add"/"edit" form
// (formName "EditForm", see ManagementPageController::bookingEditFields()),
// which mirrors the same AllDays/Days field names.
function setupAllDaysToggle(formName) {
    const allDaysElement = document.getElementById(`Form_${formName}_AllDays`);
    if (!allDaysElement) {
        return null;
    }

    function showHideDays() {
        const checkedInput = allDaysElement.querySelector("input:checked");
        const show = checkedInput && checkedInput.value === "2";
        const daysHolder = document.getElementById(`Form_${formName}_Days_Holder`);

        if (daysHolder) {
            daysHolder.style.display = show ? "" : "none";
        }
    }

    allDaysElement.querySelectorAll("input").forEach(function(input) {
        input.addEventListener("change", function() {
            showHideDays();
        });
    });

    showHideDays();

    return allDaysElement;
}

const allDaysElement = setupAllDaysToggle("Form");
setupAllDaysToggle("EditForm");

const sumElement = document.getElementById("Sum");
const hasProductPricing = !!(sumElement && sumElement.dataset.prices);

// Legacy free-registration pricing: only used on pages with no priced Seminartage
// configured at all (#Sum has no data-prices), e.g. archived registration pages.
if (allDaysElement && !hasProductPricing) {
    function updatePrice() {
        let price = 0;
        const checkedInput = allDaysElement.querySelector("input:checked");
        const full = checkedInput && checkedInput.value === "1";

        if (full) {
            price = 750;
        } else {
            const daysElement = document.getElementById("Form_Form_Days");
            const days = daysElement ? daysElement.querySelectorAll("input:checked").length : 0;
            const priceMap = {
                "0": 0,
                "1": 150,
                "2": 290,
                "3": 420,
                "4": 540,
                "5": 650,
                "6": 720,
            }
            price = priceMap[String(days)];
        }
        const formattedPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
        const priceElement = document.getElementById("price");
        if (priceElement) {
            priceElement.textContent = formattedPrice;
        }
    }

    allDaysElement.querySelectorAll("input").forEach(function(input) {
        input.addEventListener("change", updatePrice);
    });

    const daysElement = document.getElementById("Form_Form_Days");
    if (daysElement) {
        daysElement.querySelectorAll("input").forEach(function(input) {
            input.addEventListener("change", updatePrice);
        });
    }

    updatePrice();
}

// Product-based pricing: sum the selected package (Paket) + addons (Addons) using
// the price map embedded by RegistrationPageController in #Sum[data-prices]. When
// #Sum also carries data-deposit-per-person, the page reproduces the legacy "Alle
// Tage"/"Einzelne Tage" UI (via Form_Form_AllDays): "Alle Tage" shows a further
// "PaymentPlan" choice (Form_Form_PaymentPlan) between paying only a deposit now
// (remaining balance requested later by email) or the full amount today —
// "Einzelne Tage" sums whichever options are checked instead. Pages with a flat
// Gesamtpreis and SelectableDays off ($hasBasePrice server-side) carry
// data-deposit-per-person too but render no Form_Form_AllDays at all — treated
// as an implicit "Alle Tage", with any priced Zusatzoptionen checkboxes (if the
// page also has priced Days) summed on top.
if (hasProductPricing) {
    const prices = JSON.parse(sumElement.dataset.prices);
    const depositPerPerson = sumElement.dataset.depositPerPerson !== undefined
        ? parseFloat(sumElement.dataset.depositPerPerson)
        : null;
    const totalPerPerson = sumElement.dataset.totalPerPerson !== undefined
        ? parseFloat(sumElement.dataset.totalPerPerson)
        : null;
    // Restzahlung breakdown (shown under #price) — only relevant for the
    // "Anzahlung heute & Restzahlung ..." PaymentPlan choice.
    const restzahlungPerPerson = sumElement.dataset.restzahlungPerPerson !== undefined
        ? parseFloat(sumElement.dataset.restzahlungPerPerson)
        : null;
    // "Einzelne Tage" day-count lookup table (see RegistrationPage::AmountForDayCount())
    // — only present on pages with the Alle-Tage/Einzelne-Tage toggle.
    const dayTierAmounts = sumElement.dataset.dayTierAmounts !== undefined
        ? JSON.parse(sumElement.dataset.dayTierAmounts)
        : null;

    // Mirrors RegistrationPage::AmountForDayCount(): a flat lookup by day
    // count, no percentage or GesamtpaketPreis math — counts above the
    // table's highest key are capped there.
    function amountForDayCount(count) {
        if (!dayTierAmounts || count <= 0) {
            return 0;
        }
        if (dayTierAmounts[count] !== undefined) {
            return dayTierAmounts[count];
        }
        const maxDays = Math.max.apply(null, Object.keys(dayTierAmounts).map(Number));
        return count > maxDays ? dayTierAmounts[maxDays] : 0;
    }

    function formatCurrency(value) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    }

    function getFieldGroupBox(holder) {
        // Hide the whole .field.fieldgroup box, not just the inner holder —
        // otherwise its margin/padding still occupies space (visible as an extra
        // gap on mobile, where FieldGroups stack instead of floating side by side).
        return holder ? holder.closest(".field.fieldgroup") : null;
    }

    function showHideAddons() {
        const checkedInput = allDaysElement.querySelector("input:checked");
        const show = checkedInput && checkedInput.value === "2";
        const addonsBox = getFieldGroupBox(document.getElementById("Form_Form_Addons_Holder"));
        const paymentPlanBox = getFieldGroupBox(document.getElementById("Form_Form_PaymentPlan_Holder"));

        if (addonsBox) {
            addonsBox.style.display = show ? "" : "none";
        }
        if (paymentPlanBox) {
            paymentPlanBox.style.display = show ? "none" : "";
        }
    }

    function updateOptionPrice() {
        let price = 0;
        let showRestzahlungBreakdown = false;
        // Zusatzoptionen selected alongside the base package — only present
        // when the page has priced Days but no Alle-Tage/Einzelne-Tage
        // toggle. Charged immediately together with the full amount
        // ("full" PaymentPlan), but deferred to the later Restzahlung when
        // only a deposit is paid now — mirrors RegistrationPageController::register().
        let addonsSum = 0;
        document
            .querySelectorAll('input[name^="Addons"]:checked')
            .forEach(function(input) {
                addonsSum += prices[input.value] || 0;
            });

        // "Flat price" mode: either a genuine "Alle Tage" selection (pages with
        // an AllDays toggle), or a page with no toggle at all because there's
        // nothing else to pick from (flat Gesamtpreis — see
        // RegistrationPageController::$hasBasePrice).
        const checkedAllDays = allDaysElement ? allDaysElement.querySelector("input:checked") : null;
        const full = depositPerPerson !== null && (!allDaysElement || (checkedAllDays && checkedAllDays.value === "1"));

        if (full) {
            const paymentPlanChecked = document.querySelector('input[name="PaymentPlan"]:checked');
            const isFull = paymentPlanChecked && paymentPlanChecked.value === "full";
            price = isFull && totalPerPerson !== null ? totalPerPerson : depositPerPerson;
            showRestzahlungBreakdown = !isFull;
            if (isFull) {
                price += addonsSum;
            }
        } else if (allDaysElement) {
            // "Einzelne Tage": a Day with its own Price (in the #Sum data-prices
            // map) is charged exactly that; a Day with no Price (0) instead
            // counts toward the day-count tier ladder — mirrors
            // RegistrationPageController::register()/RegistrationPage::AmountForDayCount().
            let mappedCount = 0;
            document
                .querySelectorAll('input[name^="Addons"]:checked')
                .forEach(function(input) {
                    const dayPrice = prices[input.value] || 0;
                    if (dayPrice > 0) {
                        price += dayPrice;
                    } else {
                        mappedCount++;
                    }
                });
            price += amountForDayCount(mappedCount);
        } else {
            const paketChecked = document.querySelector('input[name="Paket"]:checked');
            if (paketChecked) {
                price += prices[paketChecked.value] || 0;
            }
            document
                .querySelectorAll('input[name^="Addons"]:checked')
                .forEach(function(input) {
                    price += prices[input.value] || 0;
                });
        }

        const priceElement = document.getElementById("price");
        if (priceElement) {
            priceElement.textContent = formatCurrency(price);
        }

        const restzahlungLine = document.getElementById("RestzahlungLine");
        if (restzahlungLine) {
            restzahlungLine.style.display = showRestzahlungBreakdown ? "" : "none";
            if (showRestzahlungBreakdown && restzahlungPerPerson !== null) {
                const el = document.getElementById("restzahlungPrice");
                if (el) {
                    // Zusatzoptionen deferred from the deposit (see above) are
                    // requested together with the base remaining balance.
                    el.textContent = formatCurrency(restzahlungPerPerson + addonsSum);
                }
            }
        }
    }

    if (depositPerPerson !== null) {
        if (allDaysElement) {
            allDaysElement.querySelectorAll("input").forEach(function(input) {
                input.addEventListener("change", function() {
                    showHideAddons();
                    updateOptionPrice();
                });
            });
            showHideAddons();
        }

        document
            .querySelectorAll('input[name="PaymentPlan"]')
            .forEach(function(input) {
                input.addEventListener("change", updateOptionPrice);
            });
    } else {
        document
            .querySelectorAll('input[name="Paket"]')
            .forEach(function(input) {
                input.addEventListener("change", updateOptionPrice);
            });
    }

    document
        .querySelectorAll('input[name^="Addons"]')
        .forEach(function(input) {
            input.addEventListener("change", updateOptionPrice);
        });

    updateOptionPrice();
}

document.querySelectorAll(".section--slider .slider").forEach(function(slider) {
    new Swiper(slider.querySelector(".slider_swiper"), {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
            nextEl: slider.querySelector(".slider_nav--next"),
            prevEl: slider.querySelector(".slider_nav--prev"),
        },
        pagination: {
            el: slider.querySelector(".slider_pagination"),
            clickable: true,
        },
    });
});

GLightbox({
    selector: ".glightbox"
});

$(".section--gallery .gallery_items").slick({
    dots: true,
    fade: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    // variableWidth: true
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

// Gutscheinseite (VoucherPageController::Form()): selecting "Wunschbetrag"
// swaps the button for the CustomAmount input (pure CSS, see forms.scss) —
// this just puts the cursor straight into it.
const voucherAmountElement = document.getElementById("Form_Form_Amount");
const customAmountInput = document.getElementById("Form_Form_CustomAmount");
if (voucherAmountElement && customAmountInput) {
    // Keeps the input as wide as its content (see forms.scss), so "40 €"
    // stays centred in the button. (Not CSS field-sizing: Chrome leaves a
    // gap after the text with it.)
    const fitCustomAmount = function() {
        const text = customAmountInput.value || customAmountInput.placeholder;
        customAmountInput.style.width = Math.max(text.length, 1) + 1 + "ch";
    };
    customAmountInput.addEventListener("input", fitCustomAmount);
    fitCustomAmount();

    voucherAmountElement.querySelectorAll("input.voucher-amount__radio").forEach(function(input) {
        input.addEventListener("change", function() {
            if (input.checked && input.value === "custom") {
                customAmountInput.focus();
            }
        });
    });
}
